import { authenticatedContext, userDataContext } from "../App";
import React, { useContext, useEffect } from "react";
import { getStuff } from "../helpers/auth";
import { GraphSection } from "./GraphSection";
import "../css/overview.css";

const Overview = () => {
  const { authenticated, setAuthenticated } = useContext(authenticatedContext);
  const { userData, setUserData } = useContext(userDataContext);
  const [overviewData, setOverviewData] = React.useState([]);

  useEffect(() => {
    if (!authenticated) return;
    getStuff("/get_home_page_data/").then((res) => {
      if (res.status === 200) {
        console.log(res.data);
        setOverviewData(sort_projects(res.data));
        console.log(overviewData);
      } else if (res.status === 401) {
        setAuthenticated(false);
      }
    });
  }, [authenticated]);

  return (
    <div className="overview">
      <section className="greeting-section">
        <h1 className="greeting">
          Dobrý den, <span>{userData.first_name}</span>!
        </h1>
        <p className="sub-greeting">
          Pojďme se kouknout, jak se daří vaším projektům :)
        </p>
      </section>
      {overviewData.map((project, index) => (
        <ProjectDashboard p_data={project} key={index} />
      ))}
    </div>
  );
};

export const SummaryItem = ({ imageSrc, mainText, subText, change, alt }) => {
  const [changeVal, changeText] = change;
  if (change.length > 0) {
    let changeColorClass, strVal;
    strVal = changeVal;

    if (changeVal > 0) {
      changeColorClass = "change-text-positive";
      strVal = "+" + changeVal;
    }
    if (changeVal === 0) changeColorClass = "change-text-neutral";
    if (changeVal < 0) changeColorClass = "change-text-negative";

    return (
      <div className="summary-card-item">
        <img src={imageSrc} alt={alt} className="summary-card-icon" />
        <div className="main-text">{mainText}</div>
        <div className="labels-container">
          <div className="sub-text">{subText}</div>
          <div className={"change-text " + changeColorClass}>
            {strVal + changeText}{" "}
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="summary-card-item">
        <img src={imageSrc} alt={alt} className="summary-card-icon" />
        <div className="main-text">{mainText}</div>
        <div className="labels-container">
          <div className="sub-text">{subText}</div>
        </div>  
      </div>
    );
  }
};

export const ProjectDashboard = ({ p_data, showTitle = true }) => {
  // data array for summary items
  const summaryData = [
    {
      imageSrc: "/img/svg/card_icon_equals.svg",
      mainText: p_data.client_count,
      subText: "Registrovaných klientů",
      change: [p_data.client_count_change_7d, " oproti minulému týdnu"],
      alt: "Registrovaní klienti",
    },
    {
      imageSrc: "/img/svg/card_icon_30d.svg",
      mainText: p_data.aid_last_30d + "x",
      subText: "Poskytnutá pomoc za poslední 30 dní",
      change: [p_data.compare_aid_30d, " oproti minulým 30 dnům"],
      alt: "Pomoc za 30 dní",
    },
    {
      imageSrc: "/img/svg/card_icon_7d.svg",
      mainText: p_data.aid_last_7d + "x",
      subText: "Poskytnutá pomoc za posledních 7 dní",
      change: [p_data.compare_aid_7d, " oproti minulým 7 dnům"],
      alt: "Pomoc za posledních 7 dní",
    },
    {
      imageSrc: "/img/svg/card_icon_1d.svg",
      mainText: p_data.aid_last_1d + "x",
      subText: "Poskytnutá pomoc za posledních 24 hodin",
      change: [p_data.compare_aid_1d, " oproti minulým 24 hodinám"],
      alt: "Pomoc za 24 hodin icon",
    },
  ];
  let reqUrl;
  if (p_data.project_id == null) {
    reqUrl = "/project_aid/0/aid_records/"
  }
  else {
    reqUrl = `/project_aid/${p_data.project_id}/aid_records/`
  }

  return (
    <>
      <div className="project-container">

        {showTitle && <h3 className="project-title">{p_data.name}</h3>}
        <section className="card-section">
          {summaryData.map((item, index) => (
            <SummaryItem
              key={index}
              imageSrc={item.imageSrc}
              mainText={item.mainText}
              subText={item.subText}
              change={item.change}
              alt={item.alt}
            />
          ))}

        </section>
        <GraphSection
          aidRecords={p_data.aid_records}
          reqUrl={reqUrl}
        />
      </div>
    </>
  );
};



export default Overview;

function sort_projects(projects_arr) {
  projects_arr.map((project, index) => {
    if (project.merged === true) {
      projects_arr.splice(index, 1);
      projects_arr.unshift(project);
    }
  });
  return projects_arr;
}